var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AsyncButton } from "@iscr/views/UIelems/AsyncButton";
import { useState } from "react";
/**
 * The finance actions on a profile, as offered by the edit sheet. Deliberately narrow: a profile is
 * either awaiting approval, released for sync, or held back - so at most two buttons are ever
 * relevant for a given state.
 */
export const ProfileSyncActions = ({ row, syncActions }) => {
    // The backend mirrors a transition to Firebase as it makes it, which reaches the row well before
    // the request that caused it resolves. Rendering straight off the row would therefore swap these
    // buttons out mid-action - taking the spinner on the one just clicked with them - so the state
    // the action started from is held until it settles.
    const [actingFrom, setActingFrom] = useState();
    const state = actingFrom !== null && actingFrom !== void 0 ? actingFrom : row.sap_sync_state;
    if (!state)
        return null;
    // Mid-sync profiles are left alone - changing state underneath an in-flight SAP hand-off would
    // leave the two systems disagreeing about what was sent. Checked ahead of the state below, since
    // a sync can now be in flight over any of them rather than being a state of its own. Ignored
    // while an action of our own is running, for the same reason the state above is held.
    if (!actingFrom && row.sap_syncing)
        return null;
    const run = (fn) => __awaiter(void 0, void 0, void 0, function* () {
        setActingFrom(row.sap_sync_state);
        try {
            yield fn(row.doc_id);
        }
        finally {
            setActingFrom(undefined);
        }
    });
    // AsyncButton derives its own spinner and disabled state from the returned promise. Propagation is
    // stopped so an action can't be read as a click on whatever the actions are mounted inside.
    const act = (fn) => (e) => {
        e.stopPropagation();
        return run(fn);
    };
    // Approving is no longer just a bookkeeping step - it queues the hand-off to SAP - so it asks first.
    const confirmApprove = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.stopPropagation();
        const confirmed = yield app.confirm("Approve and send to SAP", _jsxs(_Fragment, { children: [_jsxs("p", { children: ["Approve the payment profile", row.name ? " for " : "", row.name && _jsx("strong", { children: row.name }), "?"] }), _jsx("p", { children: "This queues the profile to be sent to SAP within the next few minutes." })] }), { yes: "Approve and sync", no: "Cancel" });
        if (confirmed !== "yes")
            return;
        return run(syncActions.approve);
    });
    if (state === "quarantined") {
        return (_jsx(AsyncButton, { basic: true, onClick: act(syncActions.unquarantine), children: "Release" }));
    }
    return (_jsxs("div", { className: "flex flex-nowrap justify-end gap-2", children: [state === "pending" && (_jsx(AsyncButton, { primary: true, onClick: confirmApprove, children: "Approve" })), _jsx(AsyncButton, { basic: true, onClick: act(syncActions.quarantine), children: "Quarantine" })] }));
};
